import { FileToUpload } from './filetoupload';

export class Offboarding {
  ID: number;
  EmpCode: number;
  Name: string;
  ResignationDate: Date;
  LastWorkingDay: Date;
  ExitID: number;
  Comments: string;
  ReasonID: number;
  CreatedBy: string
  CreatedDate: Date;
  ModifiedDate: Date;
  ModifiedBy: string;
  ManagerFeedBack: boolean;
  AdminFeedBack: boolean;
  ITSupportFeedback: boolean;
  HRFinalFeedback: boolean;
  FinanceFeedback: boolean;
  ManagerComments: string;
  ITComments: string;
  AdminComments: string;
  ExitEmailFileName: string;
  ExitEmailFilePath: string;
  ExitEmailFile: FileToUpload;
  Status: string;
  ResignationComments: string;
  FeedbackType: string;
  ExitCategoryComments: string;
  ItIcon: boolean;
  ManagerIcon: boolean;
  AdminIcon: boolean;
  HrIcon: boolean;
  ExitInterviewNotes: string;
  disableIcon: boolean;
  feedbackType: string;
  PeopleManagerEmail: string;
  PeopleManagerName: string;
  InitiateLWDMail: boolean = false;
  SubmittedManager: boolean;
  SubmittedIT: boolean;
  SubmittedAdmin: boolean;
  SubmittedHR: boolean;
  FinanceComments: string;
  SubmittedFinance: boolean;
  financeStatusBoolean: boolean;
  recallManager: boolean = false;
  recallIT: boolean = false;
  recallAdmin: boolean = false;
  mgrIconDept: boolean;
  ManagerSubmittedBy: number;
  ITSubmittedBy: number;
  AdminSubmittedBy: number;
  FinanceSubmittedBy: number;
  HRSubmittedBy: number;
  SubmittedManagerName: string;
  SubmittedITName: string;
  SubmittedAdminName: string;
  SubmittedHRName: string;
  SubmittedFinanceName: string;
  FinalSettlementDate: Date;
  ManagerSubmittedOn: Date;
  ITSubmittedOn: Date;
  AdminSubmittedOn: Date;
  HRSubmittedOn: Date;
  FinanceSubmittedOn: Date;
  enableEmpFeedback: boolean = false;
  FinancialYear: string;
  NewITData: boolean;
  clickingInitaiteExit: true;
  FBType: string;
  To: string;
  CC: string;
  IndicativeLWD: Date;
  ResignationAttachmentFileName : string;
  ResignationAttachmentFilePath: string;
  ResignationAttachmentFile: FileToUpload;
  finalStatus: String;
  FromEmp: boolean;
  Designation: string;
  ManagerResignationComments:string
  HRResignationComments: string
  OldManager: string;
  ErrorMsg: string;
  ProjectManagers: string;
    isThumbVisible: boolean;
    IsEmpFeedbackRequired: any;
    isThumbDisabled: boolean;
}

export const HRStatus = {
  Save: "Saved",
  Submit: "Submitted",
  Confirm: "Confirmed",
  Reject: "Rejected",
  Query: "Queried",
  Forward: "Forwarded",
}
